// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3i99M","title":"Header_title__20HhG","side":"Header_side__3frjW"};